import React, { useRef, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Icon } from '@pella/sash-framework';

const FilterButton = ({ data, selected, clearFilter, disabled, children, ...other }) => {
	const [show, setShow] = useState(false);
	const menuRef = useRef(null);

	useEffect(() => {
		document.addEventListener('mousedown', detectOutsideClick);
		return () => document.removeEventListener('mousedown', detectOutsideClick);
	}, []);

	useEffect(() => {
		if (show && selected) setShow(false);
	}, [show, selected]);

	const onFilterButtonClick = () => setShow(!show);

	const detectOutsideClick = (e) => {
		if (e.target && menuRef?.current && !menuRef.current.contains(e.target)) {
			setShow(false);
		}
	};

	return (
		<div
			className={`filter-button relative block ${show ? "before:fixed before:left-0 before:top-0 before:z-[18] before:h-screen before:w-screen before:bg-black/20 before:content-[''] md:before:content-none" : ''}`}
			data-testid='filter-button'
			ref={menuRef}
			{...other}
		>
			<button
				onClick={onFilterButtonClick}
				className={`relative block w-full border border-black px-5 py-4 text-left text-sm font-semibold xl:text-base ${selected ? 'rounded-full bg-black text-white' : 'bg-white'} ${disabled ? 'border-gray-50 bg-gray-5 opacity-50' : ''}`}
				disabled={disabled || selected}
			>
				{selected ? data.filters.find((filter) => filter.filter_tag === selected).display_name : data.category}
				{!selected && (
					<Icon
						name={show ? 'expand_less' : 'expand_more'}
						className='absolute right-4 top-1/2 -translate-y-1/2'
					/>
				)}
			</button>

			{selected && (
				<button
					className='absolute right-4 top-1/2 -translate-y-1/2 leading-none text-white'
					onClick={clearFilter}
					aria-label='Clear Filter'
				>
					<Icon
						name='close'
						size={32}
						className='block'
					/>
				</button>
			)}

			{show && (
				<div className='max-md:animate-slide-up fixed left-0 z-[19] w-full bg-white p-5 shadow-md max-md:bottom-0 max-md:rounded-[1.25rem_1.25rem_0_0] md:absolute md:top-[calc(100%+10px)] md:z-5 md:w-[calc(100%-30px)] md:border md:border-black md:p-0'>
					<button
						aria-label='Close'
						onClick={onFilterButtonClick}
						className='ml-auto block h-7 w-7 rounded-full bg-primary md:hidden'
					>
						<Icon
							name='close'
							size={20}
							className='mx-auto block'
						/>
					</button>

					{children}
				</div>
			)}
		</div>
	);
};

FilterButton.propTypes = {
	data: PropTypes.object,
	selected: PropTypes.string,
	clearFilter: PropTypes.func,
	disabled: PropTypes.bool,
	children: PropTypes.node,
};

export default FilterButton;
